module.exports = __webpack_public_path__ + "static/media/country-1.37caeb9d.jpg";